import React from 'react'

import { IconProps } from './types'

const CheckCircle: React.FC<IconProps> = ({ color, size, ...rest }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width={size}
    height={size}
    stroke={color}
    fill="none"
    {...rest}
  >
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="2"
      d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z"
    />
  </svg>
)

CheckCircle.displayName = 'CheckCircle'
CheckCircle.defaultProps = {
  size: 24,
  color: 'currentColor',
}

export default CheckCircle
